<kendo-gridlayout class="grid-layout-container" [gap]="{ rows: 0, cols: 0 }"
  [rows]="[{ height: 72 }, 'auto', { height: 42 }]" [cols]="[{ width: 114 }, 'auto']">
  <kendo-gridlayout-item [row]="1" [col]="1" [rowSpan]="3">
    <app-navigation></app-navigation>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [row]="1" [col]="2">
    <app-header></app-header>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [row]="2" [col]="2">
    <div class="page-container">
      <main class="page-content" aria-live="assertive">
        <router-outlet></router-outlet>
      </main>
    </div>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [row]="3" [col]="2">
    <footer class="footer">
      <app-footer></app-footer>
    </footer>
  </kendo-gridlayout-item>
</kendo-gridlayout>